'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-param-reassign */

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _objects = require('shallow-equal/objects');

var _objects2 = _interopRequireDefault(_objects);

var _gt = require('./gt');

var _gt2 = _interopRequireDefault(_gt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function isValidName(name) {
  return (0, _isString2.default)(name) && name.length !== 0;
}

function buildInsEventFunc(ins) {
  if (ins.hasBuildEventFunc) return;
  // ins.onReady 等方法防止多次绑定 offline模式貌似没有一些方法判断一下
  if ((0, _isFunction2.default)(ins.onReady)) ins.onReady(function () {
    if ((0, _isFunction2.default)(ins.readyFunc)) ins.readyFunc();
  });
  if ((0, _isFunction2.default)(ins.onSuccess)) ins.onSuccess(function () {
    if ((0, _isFunction2.default)(ins.successFunc)) ins.successFunc();
  });
  if ((0, _isFunction2.default)(ins.onClose)) ins.onClose(function () {
    if ((0, _isFunction2.default)(ins.closeFunc)) ins.closeFunc();
  });
  if ((0, _isFunction2.default)(ins.onError)) ins.onError(function () {
    if ((0, _isFunction2.default)(ins.errorFunc)) ins.errorFunc();
  });

  ins.handleReady = function (func) {
    ins.readyFunc = func;
  };
  ins.handleSuccess = function (func) {
    ins.successFunc = func;
  };
  ins.handleClose = function (func) {
    ins.closeFunc = func;
  };
  ins.handleError = function (func) {
    ins.errorFunc = func;
  };

  ins.hasBuildEventFunc = true;
}

function init(config, data) {
  var newConfig = {
    gt: data.gt,
    challenge: data.challenge,
    offline: !data.success,
    new_captcha: !!data.new_captcha,
    width: (0, _isNumber2.default)(config.width) ? config.width + 'px' : config.width,
    product: config.product,
    lang: config.lang,
    protocol: config.protocol,
    area: config.area,
    next_width: config.nextWidth,
    bg_color: config.bgColor,
    timeout: config.timeout
  };

  return new Promise(function (resolve, reject) {
    try {
      (0, _gt2.default)(newConfig, function (newIns) {
        resolve(newIns);
      });
    } catch (e) {
      reject(e);
    }
  });
}

var Storage = function () {
  function Storage() {
    _classCallCheck(this, Storage);

    this.instances = {};
  }

  _createClass(Storage, [{
    key: 'create',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name, newConfig, newData, useCache, ignoreData) {
        var _get, ins, data, config, newIns;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.exist(name) && useCache)) {
                  _context.next = 4;
                  break;
                }

                _get = this.get(name), ins = _get.ins, data = _get.data, config = _get.config;

                if (!(ignoreData && (0, _objects2.default)(config, newConfig) || !ignoreData && (0, _objects2.default)(config, newConfig) && (0, _objects2.default)(data, newData))) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', ins);

              case 4:
                _context.next = 6;
                return init(newConfig, newData);

              case 6:
                newIns = _context.sent;

                buildInsEventFunc(newIns);
                this.instances[name] = {
                  ins: newIns,
                  data: newData,
                  config: newConfig
                };

                return _context.abrupt('return', newIns);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'get',
    value: function get(name) {
      if (this.exist(name)) {
        return this.instances[name];
      }
      return {};
    }
  }, {
    key: 'remove',
    value: function remove(name) {
      if (this.exist(name)) {
        var _get2 = this.get(name),
            ins = _get2.ins;

        if (ins && (0, _isFunction2.default)(ins.destroy)) ins.destroy();
        delete this.instances[name];
      }
    }
  }, {
    key: 'exist',
    value: function exist(name) {
      return isValidName(name) && Object.prototype.hasOwnProperty.call(this.instances, name);
    }
  }]);

  return Storage;
}();

exports.default = new Storage();